import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';
import './CommitteeCouncil.css';
import Introduction from './Partials/Introduction';
import StickyNav from './Partials/StickyNav';
import Composition from './Partials/Compossition';
import LinkSection from './Partials/LinkSection';
import api from '../../../../api';

const CommitteeCouncil = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
         const response = await api.get("/api/sitepages/academic/committee-council");
        if (response.data.status) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  if (!data) return <div className="text-center py-5">No Data Found</div>;

  const bannerTitle = data.banner_section?.heading || 'IHEC Student';

 const bannerImageDesktop =
  data.banner_section?.desktop_images?.map(img => `/${img}`) || [];

const bannerImageMobile =
  data.banner_section?.mobile_images?.map(img => `/${img}`) || [];


    console.log(bannerImageMobile);
    
  return (
    <>
      <DynamicBanner title={bannerTitle} bgImage={bannerImageDesktop} bgImageMobile={bannerImageMobile} />
      
      {/* Section 1: Introduction Tabs (Sticky Nav) */}
      <StickyNav tabs={data.introduction_tabs} />
      
      {/* Section 2: Content & Lists */}
      <Introduction sectionData={data.section_2} baseUrl={process.env.REACT_APP_API_URL} />
      
      {/* Section 3: Composition (Detailed Tabs) */}
      <Composition sectionData={data.section_3} />
      
      {/* Section 4: PDF Downloads */}
      <LinkSection sectionData={data.section_4} baseUrl={process.env.REACT_APP_API_URL} />
    </>
  );
}

export default CommitteeCouncil;